<div class="login-register">
  <div class="login-register-panel">
    <div class="grid">
      <div class="col-6">
        <img src="assets/images/login-photo.png" alt="" />
      </div>
      <div class="col-6 p-5">
        <h3>Welcome</h3>
        <h2>Login Page</h2>
        <form [formGroup]="loginFormGroup">
          <div class="grid mt-6">
            <div class="col-12">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon"
                  ><i class="pi pi-user"></i
                ></span>
                <input
                  type="text"
                  pInputText
                  placeholder="Email"
                  formControlName="email"
                />
              </div>
              <div class="col-12">
                <small
                  *ngIf="loginForm['email'].invalid && isSubmitted"
                  class="p-error"
                >
                  <span *ngIf="loginForm['email'].errors?.['required']"
                    >Email is required</span
                  >
                  <span *ngIf="loginForm['email'].errors?.['email']"
                    >Email is invalid</span
                  >
                </small>
              </div>
            </div>
            <div class="col-12">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon"
                  ><i class="pi pi-lock"></i
                ></span>
                <input
                  type="password"
                  pInputText
                  placeholder="Password"
                  formControlName="password"
                />
              </div>
              <div class="col-12">
                <small
                  *ngIf="loginForm['email'].invalid && isSubmitted"
                  class="p-error"
                >
                  <span *ngIf="loginForm['password'].errors?.['required']"
                    >Password is required</span
                  >
                </small>
              </div>

              <div class="col-12 px-0 pt-3">
                <p-button
                  label="Submit"
                  styleClass="full-btn"
                  (onClick)="onSubmit()"
                  [disabled]="loginFormGroup.invalid"
                ></p-button>
              </div>
              <div class="col-12" *ngIf="isSubmitted && authError">
                <small class="p-error">{{ authMessage }}</small>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
